<template>
    <div dir="rtl">
      <div v-show="loading" style="width: 100%;height: 100%;position: fixed;top: 0px;left: 0px;z-index: 999;background: rgba(0,0,0,.4);">
        <img src="../../assets/images/spinner.gif" width="100" style="position: absolute;top: 50%;left: 50%;width:100px" />
         </div>
    <v-container>
        <v-layout wrap="">
             <v-flex xs12 sm12 md12>
               <p style="font-size:18px"><b><u> تقرير  قائمة العملاء لمنطقة   {{ select_region.name }}  </u> </b></p>
            </v-flex>
             <v-flex xs12 sm6 md4>
              <v-autocomplete
                    v-model="select_region"
                    :items="regions"
                    item-text="name"
                    item-value="id"
                    label=" أختر المنطقة "
                    persistent-hint
                    return-object
                    single-line
        >
          <template v-slot:append-outer>
            <v-slide-x-reverse-transition
              mode="out-in"
            >
            
            </v-slide-x-reverse-transition>
          </template>
        </v-autocomplete>
            </v-flex>
      
             <v-flex xs12 sm6 md2>
                <v-btn @click="ClientsWithRegion">تأكيد</v-btn>
            </v-flex>
        </v-layout>
      
  
      
      <v-data-table 
        :headers="headers"
        :items="fatworas"
        class="elevation-1"
        v-if="fatworas.length>0"
        :rows-per-page-items="rowsPerPageItems"

      >
        <template slot="items" slot-scope="props">
          <td>{{ props.item.code }}</td>
          <td class="text-xs-right">{{ props.item.name }}</td>
          <td class="text-xs-right">{{ props.item.Phone }}</td>
          <td class="text-xs-right">{{ props.item.region?props.item.region.name:'' }}</td>
          <td class="text-xs-right">{{ props.item.rasid_efttahi }}</td>
          <td class="text-xs-right">{{ props.item.mandob_sales?props.item.mandob_sales.name:'' }}</td>

      
        </template>
   
      </v-data-table>
      
    </v-container>
    </div>
</template>

<script>
import Vue from "vue";
import {
  items,
  search_client_by_code,
  madionia_client,
  fatworas_client_no_sadad,
  regions,
  khazina,
  khazna_fatworas,
  ClientsWithRegion
,log_me} from "../config/apiRoute.js";
export default {
  data: () => ({  user:[],
permissions:[],
    rowsPerPageItems: [400, 800],
    date_from: new Date().toISOString().substr(0, 10),
    date_to: new Date().toISOString().substr(0, 10),
    menu_from: false,
    modal_from: false,
    menu_to: false,
    modal_to: false,
    menu2: false,
    detail_dialog: false,
    add_dialog: false,
    edit_dialog: false,
  headers: [
      {
        text: " كود العميل",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: " اسم العميل",
        align: "right",
        value: "name",
        sortable: false
      },
      {
        text: "التليفون",
        align: "right",
        value: "name",
        sortable: false
      },
      {
        text: " المنطقة",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: " الرصيد الافتتاحي",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: " مندوب المبيعات",
        value: "address",
        sortable: false,
        align: "right"
      }
     
    ],
    active: "",
    select_item: { id: "" },
    select_region: { id: "" },
    search: "",
    comment: "",
    loading: true,

    khazina_fatworas: [],
    items: [],
    fatworas: [],
    regions: [],
    all_client_fatworas: [],
    all_client_sadads: [],
    theKhazna: {},
    item_detail: {},
    all_of_total: 0,
    omola_total: 0,
    count_of_count: 0,
    madionia_sabqa_of_madionia:'',madionia_sabqa:''
  }),

  computed: {
    mycode() {
      if (this.khazina_fatworas.length > 0) {
        return (this.code =
          parseInt(
            this.khazina_fatworas[this.khazina_fatworas.length - 1].code
          ) + 1);
      } else {
        return (this.code = 1000);
      }
    },
    omola_percentage() {
      return function(total, omola) {
        return parseFloat(total) * parseFloat(omola) / 100;
      };
    }
  },

  watch: {
    //    dialog (val) {
    //   val || this.close()
    // }
  },

  created() {
      this.user = JSON.parse(localStorage.getItem("user"));
    this.permissions = JSON.parse(localStorage.getItem("permission"));
    this.initialize();
  },

  methods: {
    initialize() {
      regions().then(response => {
        this.regions = response.data.regions;
        this.loading = false;
      });

      khazna_fatworas().then(response => {
        this.khazina_fatworas = response.data;
      });

      items().then(response => {
        this.items = response.data;
      });
    },
    search_client_by_code() {
      search_client_by_code(this.searchClientCode).then(response => {
        this.select_item = response.data;
        this.get_all_info();
      });
    },
    get_all_info() {
      this.searchClientCode = this.select_item.code;
      this.fatworas = [];
      this.madionia_sabqa = "";
      this.loading = true;
      fatworas_client_no_sadad(this.select_item.id).then(response => {
        this.fatworas = response.data;
        this.loading = false;
      });
      madionia_client(this.select_item.id).then(response => {
         this.madionia_sabqa =  ( response.data.madionia != 0 ? parseFloat(response.data.madionia) : 0) + (response.data.client.rasid_efttahi !='' ? parseFloat(response.data.client.rasid_efttahi) : 0);
         this.madionia_sabqa_of_madionia = ( response.data.madionia != 0 ? parseFloat(response.data.madionia) : 0)
      });
    },

    get_khazina() {
      khazina(this.select_region.id).then(response => {
        this.theKhazna = response.data;
      });
    },
    detailItem(order) {
      this.item_detail = order;
    },
    close() {
      this.add_dialog = false;
      this.edit_dialog = false;
      //   setTimeout(() => {
      //     this.editedItem = Object.assign({}, this.defaultItem)
      //     this.editedIndex = -1
      //   }, 300)
    },

    ClientsWithRegion() {
      var frmData = new FormData();
      frmData.append("region_id", this.select_region.id);
      ClientsWithRegion(frmData).then(response => {
        response.data.length > 0
          ? (this.fatworas = response.data)
          : (this.fatworas = []);
      });
    }
  }
};
</script>


<style scope>
.v-datatable__actions__range-controls {
  display: none;
}
.v-dialog.v-dialog--active {
  direction: rtl;
}
.v-label.v-label--active {
  right: 0px !important;
}
.v-label.theme--light {
  right: 0px !important;
}
</style>